/* eslint-disable import/no-named-as-default-member */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import backend from 'i18next-xhr-backend';

import { PUBLIC_URL, TRANSLATIONS_PATH } from 'lib/shared/config/config';

const FALLBACK_LNG = 'en-US';

export const initI18n = lang => {
  i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(backend)
    .init({
      lng: lang,
      ns: [],
      defaultNS: [],
      fallbackLng: FALLBACK_LNG,
      load: 'currentOnly',
      keySeparator: false, // we do not use keys in form messages.welcome
      interpolation: {
        prefix: '%',
        suffix: '%',
        escapeValue: false, // react already safes from xss
      },
      backend: {
        crossDomain: true,
        loadPath: `${PUBLIC_URL}${TRANSLATIONS_PATH}%lng%/%ns%.json`,
      },
      react: {
        useSuspense: false,
      },
    });
};
